/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import {EmptyValue} from "../../../Components/Common/EmptyValue";
import {PhoneUtils} from "../../../Utils/PhoneUtils";
import React from "react";

export function PhoneFieldViewer(props) {
    const {Value} = props;
    const value = PhoneUtils.FormatForDisplay(Value);

    if ((value ?? '') === '') {
        return <EmptyValue/>;
    }

    return value;
}
